var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"quicklink__item",attrs:{"to":{ name: 'area', params: { area: _vm.path } }}},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"arrow"},[_c('SVGlink-arrow')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }